import { addWeeks, addYears, format, getMonth, parse, startOfWeek } from "date-fns";
import _ from "lodash";
import { useEffect } from "react";
import Timeline, { CustomHeader, TimelineHeaders } from "react-calendar-timeline";
import { connect } from "react-redux";
import { Actions as LEAVEACTIONS } from "../../store/actions/leaveActions";
import TimelineItemRenderer from "./TimelineItemRenderer";

import "./ReactTimeline.css";

const todayDate = new Date();
const thisMonth = getMonth(todayDate);
const from = `${thisMonth == 0 ? format(addYears(todayDate, -1), "yyyy") : format(todayDate, "yyyy")}-01-01`;
const to = `${thisMonth >= 10 ? format(addYears(todayDate, +1), "yyyy") : format(todayDate, "yyyy")}-12-31`;

const minTime = parse(from, "yyyy-MM-dd", new Date()).valueOf();
const maxTime = parse(to, "yyyy-MM-dd", new Date());

const colors = {
	headerBackground: "#232a32", // "rgba(0,0,0,0.05)",
	headerColor: "rgba(255, 255, 255, 0.5)", //  '#fff'//"#3c434d",
	borderColor: "rgba(255, 255, 255, 0.5)", //  '#fff'//"#3c434d",
};

const ReactTimeline = ({ employees, leave, getLeave, setOpenModal, weekStartsOn }) => {
	console.log("employees", employees);
	console.log("getLeave", getLeave);
	console.log("leave", leave);

	const defaultTimeStart = startOfWeek(new Date(), { weekStartsOn });
	const defaultTimeEnd = addWeeks(startOfWeek(new Date(), { weekStartsOn }), 1);

	const maxTimeStart = parse(`${new Date().getFullYear()}-01-01`, "yyyy-MM-dd", new Date());
	const maxTimeEnd = parse(`${new Date().getFullYear()}-12-31`, "yyyy-MM-dd", new Date());

	const defaultTimeRange = defaultTimeEnd - defaultTimeStart;
	const maxTimeRange = maxTimeEnd - maxTimeStart;

	//Function to render the group rows on the timeline
	const groupRenderer = ({ group }) => {
		return (
			<div className="custom-group">
				<span className="title">{group.title}</span>
				<p className="tip">{group.tip}</p>
			</div>
		);
	};

	//Function to set the visibleTimelineRange
	const visibleTimelineRange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
		if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
			updateScrollCanvas(minTime, maxTime);
		} else if (visibleTimeStart < minTime) {
			updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart));
		} else if (visibleTimeEnd > maxTime) {
			updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime);
		} else {
			updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
		}
	};

	useEffect(() => {
		getLeave({
			from,
			to,
		});
	}, []);

	if (!leave) {
		return null;
	}

	return (
		<div>
			<Timeline
				groups={employees}
				items={leave}
				defaultTimeStart={defaultTimeStart}
				defaultTimeEnd={defaultTimeEnd}
				itemRenderer={TimelineItemRenderer}
				groupRenderer={groupRenderer}
				minZoom={maxTimeRange}
				maxZoom={defaultTimeRange}
				canMove={false}
				onTimeChange={visibleTimelineRange}
				canResize={false}
				itemTouchSendsClick={true}
				onItemClick={(itemId, e, time) => {
					console.log("leave", leave, itemId);
					const leaveItem = leave.find((leave) => leave.id == itemId).leave;
					setOpenModal(true, leaveItem);
				}}
			>
				<TimelineHeaders className="sticky">
					<CustomHeader
						height={20}
						unit="month"
					>
						{({ headerContext: { intervals }, getRootProps, getIntervalProps, showPeriod }) => {
							return (
								<div
									{...getRootProps()}
									style={{
										position: "relative",
										width: "2256px",
										height: "50px",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										backgroundColor: colors.headerBackground,
									}}
								>
									{intervals.map((interval) => {
										const intervalStyle = {
											cursor: "pointer",
											fontSize: "10px",
											textAlign: "justify",
											borderLeft: `1px solid ${colors.borderColor}`,
											borderBottom: `1px solid ${colors.borderColor}`,
											backgroundColor: colors.headerBackground,
											color: colors.headerColor,
											height: "100%",
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "center",
										};
										// console.log('This is the Interval: ', interval);
										return (
											<div
												onClick={() => {
													showPeriod(interval.startTime, interval.endTime);
												}}
												{...getIntervalProps({
													interval,
													style: intervalStyle,
												})}
											>
												<div
													className="sticky"
													style={{
														fontSize: "10px",
														textAlign: "center",
														borderStyle: "none",
													}}
												>
													{interval.startTime.format("MMM YYYY")}
												</div>
											</div>
										);
									})}
								</div>
							);
						}}
					</CustomHeader>
					<CustomHeader
						height={20}
						unit="isoweek"
					>
						{({ headerContext: { intervals }, getRootProps, getIntervalProps, showPeriod }) => {
							console.log("Intervals: ", intervals);
							return (
								<div
									{...getRootProps()}
									style={{
										position: "relative",
										width: "2256px",
										height: "50px",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										backgroundColor: colors.headerBackground,
									}}
								>
									{intervals.map((interval) => {
										const intervalStyle = {
											cursor: "pointer",
											fontSize: "10px",
											textAlign: "justify",
											borderLeft: `1px solid ${colors.borderColor}`,
											borderBottom: `1px solid ${colors.borderColor}`,
											backgroundColor: colors.headerBackground,
											color: colors.headerColor,
											height: "100%",
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "center",
										};
										// console.log('This is the Interval: ', interval);
										return (
											<div
												onClick={() => {
													showPeriod(interval.startTime, interval.endTime);
												}}
												{...getIntervalProps({
													interval,
													style: intervalStyle,
												})}
											>
												<div
													className="sticky"
													style={{
														fontSize: "10px",
														textAlign: "center",
														borderStyle: "none",
													}}
												>
													{interval.startTime.format("Do MMM")} -{" "}
													{interval.endTime.format("Do MMM")}
												</div>
											</div>
										);
									})}
								</div>
							);
						}}
					</CustomHeader>
					<CustomHeader
						height={50}
						unit="day"
					>
						{({ headerContext: { intervals }, getRootProps, getIntervalProps, showPeriod }) => {
							console.log("Intervals: ", intervals);
							return (
								<div
									{...getRootProps()}
									style={{
										position: "relative",
										width: "2256px",
										height: "50px",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										backgroundColor: colors.headerBackground,
									}}
								>
									{intervals.map((interval) => {
										const intervalStyle = {
											fontSize: "10px",
											textAlign: "justify",
											borderLeft: `1px solid ${colors.borderColor}`,
											backgroundColor: colors.headerBackground,
											color: colors.headerColor,
											height: "100%",
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "center",
										};
										// console.log('This is the Interval: ', interval);
										return (
											<div
												// onClick={() => {
												//   showPeriod(interval.startTime, interval.endTime);
												// }}
												{...getIntervalProps({
													interval,
													style: intervalStyle,
												})}
											>
												<div
													className="sticky"
													style={{
														fontSize: "10px",
														textAlign: "center",
														borderStyle: "none",
													}}
												>
													{interval.startTime.format("ddd D")}
												</div>
											</div>
										);
									})}
								</div>
							);
						}}
					</CustomHeader>
				</TimelineHeaders>
			</Timeline>
		</div>
	);
};

const mapStateToProps = (state) => {
  const {
    timelineLeaveLoading,
    timelineLeave,
    leaveTypes,
    currentDepartment,
  } = state.leave;

  //All the company's employee
  const employeeListWithSalary =
    state && state.employees && state.employees.employeeListWithSalary;

  const employeeOptions =
    employeeListWithSalary &&
    employeeListWithSalary.map((employee) => ({
      value: employee.id,
      label: `${employee.employeeName} ${employee.employeeSurname}`,
      jobType: employee.employmentTypeName,
    }));

  // const sortedLeave = _.orderBy(
  //   timelineLeave,
  //   ['date', 'employeeName', 'employeeSurname'],
  //   ['desc', 'asc', 'asc']
  // );

  const items = timelineLeave && timelineLeave.map((leave) => {
    const { agreement, id, type, date, dateTo, endTime, hours, status} = leave || {};
    const leaveType = leaveTypes && leaveTypes.find((type) => type.id == type);
    // console.log('LeaveType: ', leaveType, leave);
    return {
      //item[i].id must be unique
      id: id,
      //item[i].group property must have the same id as group[i].id
      group: agreement,
      type: type,
      title: leaveType?.name,
      start_time: parse(date, "yyyy-MM-dd", new Date()),
      status: status,
      end_time: parse(((dateTo || date) + " " + endTime || "23:59" ), "yyyy-MM-dd HH:mm", new Date()),
      totalHours: hours,
      leave,
      // itemProps: {
      //   onDoubleClick: () => {
      //     console.log('doubleClicking??')
      //     setOpenModal(true,leave)
      //   }
      // }
    };
  });

  const groups = employeeListWithSalary && employeeListWithSalary.map((people) => {
    return {
      department: `${people.departmentName}`,
      id: people.id,
      height: 30,
      title: `${people.employeeName} ${people.employeeSurname}`,
    };
  });

  return {
    weekStartsOn: state.company?.settings?.jurisdiction === 'UK' ? 0 : 1,
    timelineLeaveLoading,
    leave: items,
    leaveTypes,
    currentDepartment,
    employees: _.orderBy(groups,['department','title'],['ASC','ASC']),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (status, leave) =>
    dispatch(LEAVEACTIONS.setOpenModal(status, leave)),
  getLeave: (options) => dispatch(LEAVEACTIONS.leaveGet(options, false, true)),
  /*  getLeaveBalance: () => dispatch(LEAVEACTIONS.getLeaveBalance()),
    getLeaveBalanceReport: () => dispatch(LEAVEACTIONS.getLeaveBalanceReport()),
    saveLeave: (leave) => dispatch(LEAVEACTIONS.saveLeave(leave)),
    showCancelLeave: (leave,status) => dispatch(LEAVEACTIONS.showCancelLeave(leave,status)), */
});

export default connect(mapStateToProps, mapDispatchToProps)(ReactTimeline);
